export const CheckIcon = ({ size = 20, color = "white", ...props }) => (
  <svg fill="none" height={size} viewBox="0 0 49 49" width={size} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M43.0276 10.684H39.7901C39.3362 10.684 38.9054 10.893 38.6275 11.2505L19.531 35.5005L10.3742 23.87C10.2357 23.6937 10.0591 23.5511 9.85775 23.453C9.6564 23.3549 9.4355 23.3038 9.21162 23.3035H5.97407C5.66374 23.3035 5.49237 23.661 5.68227 23.9025L18.3685 40.0135C18.9613 40.7656 20.1007 40.7656 20.6982 40.0135L43.3194 11.2783C43.5093 11.0415 43.338 10.684 43.0276 10.684Z"
      fill={color}
    />
  </svg>
);
